import React from 'react'
import { Formik, Form, Field, FieldArray } from 'formik'
import {
  Button,
  Checkbox,
  Grid,
  TextField,
  Typography
} from '@mui/material'
import { DeleteIconButton } from '../../../components/Buttons/DeleteIconButton'
import { WebhookSubscriber } from '../../../interfaces/Webhook'
import { WebhookSubscriberSchema, availableWebhookEvents } from './config'
import { CustomErrorMessage } from '../../../components/_WMS/CustomErrorComponent/CustomErrorComponent'

interface WebhookSubscriberFormProps {
  initialValues: WebhookSubscriber
  onSubmit: (webhookSubscriber: WebhookSubscriber) => void
}

export const WebhookSubscriberForm: React.FC<WebhookSubscriberFormProps> = ({
  initialValues,
  onSubmit
}) => {
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={WebhookSubscriberSchema}
      onSubmit={(values, { setSubmitting }) => {
        // Aquí manejas el envío de los datos
        onSubmit(values)
        setSubmitting(false)
      }}
    >
      {({ values, isSubmitting, setFieldValue }) => (
        <Form>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                type='text'
                name='webHookUrl'
                as={TextField}
                variant='outlined'
                fullWidth
                label={'URL'}
              />
              <CustomErrorMessage name='webHookUrl' component='div' />
            </Grid>

            <Grid item xs={8} sm={10}>
              <Field
                type='text'
                name='secret'
                as={TextField}
                variant='outlined'
                fullWidth
                label={'Secreto'}
              />
              <CustomErrorMessage name='secret' component='div' />
            </Grid>
            <Grid item xs={4} sm={2}>
              <label>
                <Field type='checkbox' name='active' as={Checkbox} />
                <CustomErrorMessage name='active' component='div' />
                {'Activo'}
              </label>
            </Grid>
            <Grid container item xs={12}>
              <FieldArray name='headers'>
                {({ remove, push }) => (
                  <Grid container item xs={12} spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant='body2'>Headers</Typography>
                    </Grid>
                    {values.headers.length > 0 &&
                      values.headers.map((_header, index) => (
                        <Grid container item xs={12} key={index} spacing={2}>
                          <Grid item xs={12} sm={5}>
                            <Field
                              name={`headers.${index}.name`}
                              as={TextField}
                              variant='outlined'
                              fullWidth
                              label={'Key'}
                            />
                            <CustomErrorMessage
                              name={`headers.${index}.name`}
                              component='div'
                            />
                          </Grid>
                          <Grid item xs={12} sm={5}>
                            <Field
                              name={`headers.${index}.value`}
                              as={TextField}
                              variant='outlined'
                              fullWidth
                              label={'Value'}
                            />
                            <CustomErrorMessage
                              name={`headers.${index}.value`}
                              component='div'
                            />
                          </Grid>
                          <Grid item xs={12} sm={1}>
                            <DeleteIconButton
                              onClick={() => remove(index)}
                              isDisabled={false}
                            />
                          </Grid>
                        </Grid>
                      ))}
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant='outlined'
                        color='primary'
                        type='button'
                        onClick={() =>
                          push({ webHookHeaderId: 0, name: '', value: '' })
                        }
                      >
                        Agregar Header
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </FieldArray>
            </Grid>
            <Grid item xs={12}>
              {availableWebhookEvents.map((event) => (
                <label key={event.webHookEventId}>
                  <Field
                    as={Checkbox}
                    type='checkbox'
                    name='subscribedEvents'
                    value={event.webHookEventId.toString()}
                    checked={values.subscribedEvents.some(
                      (e) => e.webHookEventId === event.webHookEventId
                    )}
                    onChange={() => {
                      if (
                        values.subscribedEvents.some(
                          (e) => e.webHookEventId === event.webHookEventId
                        )
                      ) {
                        // Desuscribir el evento
                        const nextEvents = values.subscribedEvents.filter(
                          (e) => e.webHookEventId !== event.webHookEventId
                        )
                        setFieldValue('subscribedEvents', nextEvents)
                      } else {
                        // Suscribir el evento
                        const nextEvents = values.subscribedEvents.concat([
                          {
                            webHookSubscriberId: values.webhookSubscriberId,
                            webHookEventId: event.webHookEventId
                          }
                        ])
                        setFieldValue('subscribedEvents', nextEvents)
                      }
                    }}
                  />
                  {event.name}
                </label>
              ))}
            </Grid>
            <Grid item xs={12}>
              <Button
                variant='contained'
                color='primary'
                fullWidth
                type='submit'
                disabled={isSubmitting}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  )
}
